











































































import { Component, Vue, Watch } from 'vue-property-decorator';
import PagingUnit from '@/components/paging/paging.vue';
import CollapseTransition from '@/components/collapseTransition/collapseTransition.ts';
import { TableStripe } from '@/mixins/tableStripe';
import { performanceServer } from '@/api/installServer';

import HazardDetail from '@/views/inspectionContents/rectificationNotice/hazardDetail.vue';

@Component({
  components: {
    PagingUnit,
    CollapseTransition,
    HazardDetail,
  },
  mixins: [TableStripe],
})
export default class DelayAuditList extends Vue {
  @Watch('searchFormData.alreadyAudit')
  private searchDept(val: any) {
    this.queryDataForm.pageNo = 1;
    this.getTableList();
  }

  showList = true; // 控制显示的组件
  row: object = {}; // 传递一行的值

  queryDataForm: any = {
    pageNo: 1,
    pageSize: 10,
  };
  total = 0; // 数据总共多少条
  searchFormData: any = {
    alreadyAudit: false,
  }; // 搜索栏的数据对象
  tableData: Array<any> = []; // 表格的数据对象

  private levelText: any = {
    D: '一般隐患III级(D)',
    C: '一般隐患II级(C)',
    B: '一般隐患I级(B)',
    A: '重大隐患(A)',
  };
  private delayStatus: any = {
    1: '待审核',
    2: '已延期',
    3: '已驳回',
    4: '已取消',
  }; // 延期状态

  created() {
    this.getTableList();
  }
  private getTableList() {
    performanceServer
      .delayAuditList({
        pageNo: this.queryDataForm.pageNo,
        pageSize: this.queryDataForm.pageSize,
        alreadyAudit: this.searchFormData.alreadyAudit,
      })
      .then((res: any) => {
        this.tableData = res.data.records;
        this.total = res.data.total;
      });
  }

  /**
   * @desc  分页发生改变触发，获取到新的 table 数据。
   * @param1 暂无
   * @returns 暂无
   */
  getListData() {
    this.getTableList();
  }

  hazardInfo(data: any) {
    this.showList = false;
    this.row = data;
  }
  hazardDetailResponse() {
    this.showList = true;
    this.getTableList();
  }
  backRectifyIndex() {
    this.$emit('backRectifyIndex');
  }
}
